import React from 'react';

export default {
  en: {
    goToDeposit: 'Go to deposit',
    tradingRankList: 'TRC20-USDT Net Deposits Ranking List',
    yourTradingVolumn: 'TRC20-USDT Net Deposits Volume',
    yourRanking: 'Total Interest',
    tradeVolumn: 'Net Deposits Volume',
    asset: 'USDT-TRON',
    isTradingRank: true,
    name: 'USDT',
    symbol: 'NPXS_BTC',
    pageTitle: 'Deposit TRC20-USDT To Earn 16% APR and Win 160,000 TRC20-USDT!',
    pageDescription:
      `To celebrate TRC20-USDT deposits being enabled on Binance.com, Binance and the TRON team have committed to provide 16% 
      APR on TRC20-USDT deposits for users, as well as a 160,000 TRC20-USDT prize pool for a net deposits ranking competition.`,
    banner: {
      pc: {
        height: 500,
        path: './images/pc/usdt_web_en.png',
      },
      mobile: {
        height: 234,
        path: './images/mobile/usdt_app_en.png',
      },
    },
    time: 'Promotion period: 2019/10/01 0:00 AM to 2019/10/21 0:00 AM (UTC).',
    updataTime: 'Update: Data will now be updated at 2:30 AM(UTC) on the following day.',
    description: (
      <>
        To celebrate TRC20-USDT deposits being enabled on Binance.com, Binance and the TRON team have committed to provide 16%
      APR on TRC20-USDT deposits for users, as well as a 160,000 TRC20-USDT prize pool for a net deposits ranking competition.
      </>
    ),
    partA: {
      title: 'Deposit TRC20-USDT and Earn 16% APR',
      desc: (
        <>
          All users with net deposits (deposits minus withdrawals) of at least 100 TRC20- USDT on
          Binance.com during the promotion period will automatically earn 16% APR on their net
          deposit amount over this period.
        </>
      ),
      rewards: [],
    },
    partB: {
      title: 'Net Deposits Competition, 160,000 TRC20-USDT to Win!',
      desc: (
        <>
          <p>
            All users will be ranked in terms of total TRC20-USDT net deposits on their Binance
            account (deposits minus withdrawals) during the promotion period and will split 160,000
            TRC20-USDT according to the rewards structure below:
          </p>
        </>
      ),
      rewards: [
        { orderNo: '1', title: '1st Place', desc: '1st Place will receive 50,000 TRC20-USDT' },
        { orderNo: '2', title: '2nd Place', desc: '2nd Place will receive 30,000 TRC20-USDT' },
        { orderNo: '3', title: '3rd Place', desc: '3rd Place will receive 20,000 TRC20-USDT' },
        {
          orderNo: '4',
          title: '4th-20th Place',
          desc: 'equally split a pool of 60,000 TRC20-USDT',
        },
      ],
    },
    terms: [
      'You will be able to see your net deposits, cumulative rewards and rank after October 9th, 2019.',
      'Calculation formula: Daily interest received = Net TRC20-USDT deposits X Daily holding time ÷ 24hours X 16% APR ÷ 365 days',
      `Each full day refers to 0:00 AM to 0:00 AM (UTC) of the next day, a full 24 hours. the minimum unit of valid holding 
      time for earning rewards is 1 hour. For instance, 2 hours and 45 minutes is considered as 2 hours holding time.`,
      `Net TRC20-USDT deposits = TRC20-USDT deposits minus withdrawals. Withdrawals include TRC20-USDT, OMNI-USDT 
      and ERC20-USDT. Users may trade the TRC20-USDT that is deposited.`,
      'Sub-accounts and master accounts will be treated as one account when participating in this activity.',
      'Participants are eligible to win prizes across both promotions above.',
      `Rewards will be distributed within 2 weeks after the competition ends. 
      You will be able to login and see your rewards via Distribution History > Account Center.`,
      'Binance reserves the right to cancel or amend the competition or competition rules at our sole discretion.',
    ],
    riskTip:
      `Cryptocurrency investment is subject to high market risk. Binance is not responsible for any direct, 
      indirect or consequential losses as a result of the trading competition. Please make your investments with caution.`,
  },
  cn: {
    goToDeposit: '去充值',
    tradingRankList: 'TRC20-USDT 净充值排行版',
    yourTradingVolumn: 'TRC20-USDT净充值量',
    yourRanking: '总利息',
    tradeVolumn: '净充值',
    asset: 'USDT-TRON',
    isTradingRank: true,
    name: 'USDT',
    symbol: 'NPXS_BTC',
    pageTitle: '充TRC20-USDT享16%的年化收益，瓜分160,000 TRC20-USDT大奖',
    pageDescription:
      '为庆祝TRC20网络格式的USDT上线Binance，Binance联手波场（TRON）举办充值送活动。活动期间，凡在Binance官网充值TRC20-USDT，可享受16%的年化收益，同时享160,000 TRC20-USDT净充值排名大奖。双重大奖，双重好礼。这个10月，你敢充，我们就敢送。',
    banner: {
      pc: {
        height: 500,
        path: './images/pc/usdt_web_cn.png',
      },
      mobile: {
        height: 234,
        path: './images/mobile/usdt_app_cn.png',
      },
    },
    time: '2019年10月01日 上午8:00 -2019年10月21日上午8:00 (香港时间）',
    description:
      '为庆祝TRC20网络格式的USDT上线Binance，Binance联手波场（TRON）举办充值送活动。活动期间，凡在Binance官网充值TRC20-USDT，可享受16%的年化收益，同时享160,000 TRC20-USDT净充值排名大奖。双重大奖，双重好礼。这个10月，你敢充，我们就敢送。',
    updataTime: '数据更新：次日上午10:30后更新（香港时间）',
    partA: {
      title: '充值TRC20-USDT，享16%年化收益',
      desc: (
        <>
          活动期间，凡在Binance官网TRC20-USDT净充值（充值-提现）达到100
          USDT的用户，享受16%的年化收益。
        </>
      ),
      rewards: [],
    },
    partB: {
      title: '净充值排行榜，瓜分160,000 USDT大奖',
      desc: (
        <>
          <p>
            活动期间，凡在Binance官网TRC20 USDT净充值（充值-提现）达到100
            USDT的用户，根据TRC20-USDT净充值量进行排名，瓜分160,000 USDT大奖。奖励规则如下：
          </p>
        </>
      ),
      rewards: [
        { orderNo: '1', title: '第1名', desc: '50,000  TRC20-USDT' },
        { orderNo: '2', title: '第2名', desc: '30,000  TRC20-USDT' },
        { orderNo: '3', title: '第3名', desc: '20,000  TRC20-USDT' },
        { orderNo: '4', title: '第4-20名', desc: '平分60,000 TRC20-USDT' },
      ],
    },

    terms: [
      '10月9日以后，用户可以每天查询自己的TRC20-USDT净充值量、排名和总利息数据。',
      '计算公式：每日利息=净充值 X 每日持仓时间 ÷ 24小时 X 16%年化收益 ÷ 365天。',
      '每天的计时：从上午8:00至次日上午8:00（香港时间），持仓时间向下取整数。不足1小时不计入持仓时间',
      '净充值=充值-提现，提现包含ERC20, OMNI, TRC20三个网络格式的USDT。用户交易不受限制',
      '子母账号将被视为同一账号参与活动。',
      '用户可以同时获得活动一和活动二的奖励。',
      '奖励发放：奖励将在活动结束后2周内发放，可在用户中心-分发记录查看。',
      '活动最终解释权归Binance所有。',
    ],
    riskTip:
      '数字货币是一种高风险的投资方式，请投资者谨慎购买，并注意投资风险。Binance会遴选优质币种，但不对投资行为承担担保、赔偿等责任。',
  },
};
